import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, buttons" width="100%" theme="lightest" alignment="yes" variantsTypePrimary='secondary' variantStyleFill="outline" className="py-0 text-align-left  div-p-0 ms-left-content link linking ms-btm-right-cont" mdxType="TextBlock" />
    <h3 {...{
      "id": "have-questions"
    }}>{`Have questions?`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../pricing/contact.md"
        }}>{`Go to FAQ`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      